import { Loader2 } from 'lucide-react';
import { Skeleton } from '@/components/ui/skeleton';

interface LoadingStateProps {
  message?: string;
  variant?: 'spinner' | 'skeleton';
}

export function LoadingState({
  message = 'Carregando...',
  variant = 'spinner',
}: LoadingStateProps) {
  if (variant === 'skeleton') {
    return (
      <div className="space-y-3">
        <Skeleton className="h-24 w-full" />
        <Skeleton className="h-24 w-full" />
        <Skeleton className="h-24 w-full" />
      </div>
    );
  }
  return (
    <div className="flex flex-col items-center justify-center p-12 text-sm text-muted-foreground">
      <Loader2 className="mb-3 h-6 w-6 animate-spin" />
      {message}
    </div>
  );
}
